import { useContext } from "react";
import { UserContext } from "../context/user";
import { HotelContext } from "../context/hotel";

const useApiBff = () => {
    const { data: hotel } = useContext(HotelContext);
    const { caching } = useContext(UserContext);

    let _host = "https://api-pwa.vicomanager.com/v1";
    let _host_cached = _host;
    if (process.env.REACT_APP_APP_ENV === 'dev' || process.env.REACT_APP_APP_ENV === 'local') {
        _host = "https://api-pwa-dev.vicomanager.com/v1";
        _host_cached = _host;
        if (caching) {
            _host_cached = "https://cdn-api-pwa-dev.vicomanager.com/v1";
        }
    } else {
        if (caching) {
            _host_cached = "https://cdn-api-pwa.vicomanager.com/v1";
        }
    }

    const _makeUrl = (path, cachable = false) => {
        let api_host = cachable ? _host_cached : _host;
        return `${api_host}/${path}`
    };

    const get = async (path) => {
        try {
            let _cachable = path.indexOf('/checkins/') === -1 &&
                path.indexOf('/stays/') === -1 &&
                path.indexOf('/reservations/') === -1 &&
                path.indexOf('/bookables/') === -1 &&
                path.indexOf('/public/') === -1 &&
                // path.indexOf('/upselling') === -1 && 
                // path.indexOf('/upselling') === -1 && 
                path.indexOf('/bookables') === -1 &&
                path.indexOf('/reservations_by_data/') === -1;
        
            let headers = { 'Content-Type': 'application/json' }
    
            const options = {
                method: 'GET',
                headers
            }
            if (path.indexOf('/checkins/') !== -1 || path.indexOf('/stays/') !== -1) {
                const token = localStorage.getItem('token-' + hotel.id + '-checkin');
                if (token) {
                    options['headers']['Authorization'] = `Bearer ${token}`;
                }
                _cachable = false;
            }
            if (path.indexOf('/public/') !== -1) {
                const personToken = localStorage.getItem('ViCo::token-' + hotel.id + '-person');
                if (personToken) {
                    options['headers']['Authorization'] = `Bearer ${personToken}`;
                }
            }
            let response = await fetch(_makeUrl(path, _cachable), options);
            if (!response.ok) {
                let err = 'Error Response';
                let status = response.status;
                if (status === 401) {
                    let reason = {};
                    try {
                        reason = await response.json();
                    } catch (parseErr) {}
                    if (reason?.reason) {
                        err = reason.reason;
                    }
                    // Lanzamos objeto incluyendo status
                    throw { status: 401, message: err };
                } else {
                    throw new Error(err);
                }
            }
            const resp_json = await response.json();
    
            if (path.indexOf('/reservations/') !== -1 || path.indexOf('/token') !== -1 || path.indexOf('/reservations_by_data/') !== -1) {
                if (resp_json?.token?.name && resp_json?.token?.value) {
                    localStorage.setItem(resp_json.token.name, resp_json.token.value);
                    delete resp_json["token"]
                }
            }
            return resp_json;
        } catch (error) {
            throw error;
        }
    }

    const post = async (path, body) => {
        let headers = { 'Content-Type': 'application/json' };
        const options = {
            method: 'POST',
            headers,
            body: JSON.stringify(body) // Convierte el cuerpo del request a JSON
        }
        options["credentials"] = 'include';
        const token = localStorage.getItem('token-' + hotel.id + '-checkin');
        if (token) {
            options['headers']['Authorization'] = `Bearer ${token}`;
        }

        const personToken = localStorage.getItem('ViCo::token-' + hotel.id + '-person');
        if (personToken) {
            options['headers']['Authorization'] = `Bearer ${personToken}`;
        }

        let response = await fetch(_makeUrl(path), options);
        if (!response.ok) {
            let err = 'Error Response';
            if (response.status === 401) {
                const reason = await response.json();
                if (reason?.reason) {
                    err = reason.reason;
                }
            }
            throw new Error(err);
        }
        return await response.json();
    }

    const put = async (path, body) => {
        let headers = { 'Content-Type': 'application/json' };
        const options = {
            method: 'PUT',
            headers,
            body: JSON.stringify(body)
        };
        options["credentials"] = 'include';
        const token = localStorage.getItem('token-' + hotel.id + '-checkin');
        if (token) {
            options['headers']['Authorization'] = `Bearer ${token}`;
        }
        let response = await fetch(_makeUrl(path), options);
        if (!response.ok) {
            let err = 'Error Response';
            if (response.status === 401) {
                const reason = await response.json();
                if (reason?.reason) {
                    err = reason.reason;
                }
            }
            throw new Error(err);
        }
        return await response.json();
    };

    const patch = async (path, body) => {
        let headers = { 'Content-Type': 'application/json' };
        const options = {
            method: 'PATCH',
            headers,
            body: JSON.stringify(body)
        };
        options["credentials"] = 'include';
        const token = localStorage.getItem('token-' + hotel.id + '-checkin');
        const personToken = localStorage.getItem('ViCo::token-' + hotel.id + '-person');
        if (token) {
            options['headers']['Authorization'] = `Bearer ${token}`;
        }
        if (personToken) {
            options['headers']['Authorization'] = `Bearer ${personToken}`;
        }
        let response = await fetch(_makeUrl(path), options);
        if (!response.ok) {
            let err = 'Error Response';
            if (response.status === 401) {
                const reason = await response.json();
                if (reason?.reason) {
                    err = reason.reason;
                }
            }
            throw new Error(err);
        }
        return await response.json();
    };

    return { get, post, put, patch }
}

export default useApiBff;